import { Component, OnInit, isDevMode, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ListsService, AuthenticationService } from 'src/app/_services';
import { Router } from '@angular/router';

declare const $ :any;


@Component({
  selector: 'app-new-list-modal',
  templateUrl: './new-list-modal.component.html',
  styleUrls: ['./new-list-modal.component.css']
})
export class NewListModalComponent implements OnInit {

  public newListForm : FormGroup;
  public submitted : boolean;

  constructor(
    private formBuilder: FormBuilder,
    private toastr : ToastrService,
    private lists : ListsService,
    private router : Router
  ) {
  }

  ngOnInit() {

    this.newListForm = this.formBuilder.group({
      name: ['',  Validators.required],
    });
  }

  get f() { 
    return this.newListForm.controls; 
  }

  onSubmit(){
    this.submitted = true;

    if (this.newListForm.invalid){
      return;
    }
  
    const  name : string  = this.f.name.value ?  this.f.name.value : '' ;
   
    this.lists.add(name).subscribe(result => {
      this.router.navigate(['/user/list/' + result]);
      $('#modal-new-list').modal('hide');
      this.newListForm.controls.name.setValue('');
      this.submitted = false;
    });
  
    
  }


}
